import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { FulfillmentGroupUpdate } from "@redotech/redo-merchant-fulfillment-rpc/schema/update-fulfillment-groups";
import { memo } from "react";
import { FulfillmentNotes } from "../../common/notes";

export const FulfillmentNotesSlideout = memo(function FulfillmentNotesSlideout({
  fulfillmentGroups,
  updateRows,
  everythingDisabled,
}: {
  fulfillmentGroups: readonly FulfillmentGroupData[];
  updateRows: (updates: FulfillmentGroupUpdate[]) => void;
  everythingDisabled: boolean;
}) {
  return (
    <FulfillmentNotes
      everythingDisabled={everythingDisabled}
      fulfillmentGroups={fulfillmentGroups}
      updateRows={updateRows}
    />
  );
});
